
import React, { useEffect, useState } from "react";
import "./FilterAllUsers.css";
import { useGlobalContext } from "../../context";
import TuneIcon from '@mui/icons-material/Tune';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

function FilterAllUsers() {
    
    const {
        categorys, 
        showFilterBox, 
        setShowFilterBox,
        allUsers, 
        setShowUsers,
        showUsers,
        setCategorys,
        countryData,
    } = useGlobalContext()
    
    const [showCategoryBox, setShowCategoryBox] = useState(false);
    const [showProfileTypeBox, setShowProfileTypeBox] = useState(false);
    const [fullName, setFullName] = useState("");
    const [facebookID, setFacebookID] = useState("");
    const [instagramID, setInstagramID] = useState("");
    const [category, setCategory] = useState("");
    const [typeProfile, setTypeProfile] = useState("");
    const [country, setCountry] = useState("");
    
    const openFilterBox = () => {
        setShowFilterBox(!showFilterBox);
    }
    
    const clearFilterData = async () => {
        setCategorys(categorys => categorys.map(item => item.id === 1 ? { ...item, active: true } : { ...item, active: false }));
        setFullName("");
        setFacebookID("");
        setInstagramID("");
        setCategory("");
        setTypeProfile("");
        setCountry("")
        setShowUsers(allUsers);
    }

    useEffect(() => {
        setCategorys(categorys => categorys.map(item => item.text === "REAL ESTATE" ? { ...item, active: true } : { ...item, active: false }));
    },[fullName, facebookID, instagramID, category, typeProfile])
    
    const filterUsersList = () => {
        setShowUsers(allUsers);
            let data = {
            category: category ? category.replaceAll(" ", "_") : null,
            facebookProfileId: facebookID,
            instagramProfileId: instagramID,
            subscription: typeProfile ? typeProfile.replaceAll(" and ", "_").toUpperCase() : null,
            fullName: fullName,
            country: country,
        }
        
        for (let key in data) {
            if (data[key]) {
                if (key === "subscription") {
                    setShowUsers(showUsers => showUsers.filter(item => item[key] === data[key]));
                }
                else {
                    setShowUsers(showUsers => showUsers.filter(item => item[key] && item[key].toLowerCase().includes(data[key].toLowerCase())));
                }
            }
        }
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    return(
        <div className = "FilterAllUsersBox" >
            <div className = "filterUsersIconBox" >
                <TuneIcon 
                    style = {{
                        color: "#3F68B1", 
                        margin: "0 5px", 
                        fontSize: "1.6rem", 
                        cursor: "pointer"
                    }}
                    onClick = { openFilterBox }
                /> 
                <span className = "filterUsersIconBoxText" onClick = { openFilterBox }>Filter</span>
            </div>
            <div className = "filterInputsBtnsBox" 
                 style = {{
                     display: showFilterBox ? "flex" : "none",
                 }}
            >
                <div className = "filterInputsBox">
                    <span className = "filterInputsSpan">
                        <input 
                            type = "text"
                            className = "filterInput" 
                            name = "Full Name" 
                            placeholder = "FULL NAME"
                            value = { fullName }
                            onChange = { e => setFullName(e.target.value) }
                        />
                    </span>
                    <span className = "filterInputsSpan">
                        <input 
                            type = "text"
                            className = "filterInput" 
                            name = "Full Name" 
                            placeholder = "FACEBOOK ID"
                            value = { facebookID }
                            onChange = { e => setFacebookID(e.target.value) }
                        />
                    </span>
                    <span className = "filterInputsSpan">
                        <input 
                            type = "text"
                            className = "filterInput" 
                            name = "Full Name" 
                            placeholder = "INSTAGRAM ID"
                            value = { instagramID }
                            onChange = { e => setInstagramID(e.target.value) }
                        />
                    </span>
                    <span className = "filterInputsSpan">
                        <span className = "selectBox"
                              onClick = {() => {
                                  setShowCategoryBox(!showCategoryBox);
                                  setShowProfileTypeBox(false)
                              }}
                        >
                            {
                                category ? category : "CATEGORY"
                            }
                            <KeyboardArrowDownIcon 
                                style = {{
                                    color: "#999999", 
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                        <div 
                            className = "selectHideBox" 
                            style = {{
                                display: !showCategoryBox ? "none" : "flex"
                            }}
                        >
                            {
                                categorys.map(item => item.id !== 0 ?
                                    <span
                                        className = "selectConcretType"
                                        key = { item.id }
                                        onClick = {() => {
                                            setCategory(item.text);
                                            setShowCategoryBox(false);
                                        }}
                                    >
                                        { item.text }
                                    </span>
                                    : null
                                )
                            }
                        </div>
                    </span>
                    <span className = "filterInputsSpan"
                          style = {{ width: "250px" }}
                    >
                        <span 
                              className = "selectBox"
                              onClick = {() => {
                                  setShowProfileTypeBox(!showProfileTypeBox);
                                  setShowCategoryBox(false)
                              }}
                        >
                            {
                                typeProfile ? typeProfile : "PROFILE TYPE"
                            }
                            <KeyboardArrowDownIcon 
                                style = {{
                                    color: "#999999", 
                                    cursor: "pointer"
                                }}
                            />
                        </span>
                        <div 
                             className = "selectHideBox" 
                             style = {{
                                 display: !showProfileTypeBox ? "none" : "flex"
                             }}
                        >
                            <span 
                                className = "selectConcretType" 
                                onClick = {() => {
                                    setTypeProfile("Facebook");
                                    setShowProfileTypeBox(false)
                                }}
                            >
                                Facebook
                            </span>
                            <span 
                                className = "selectConcretType" 
                                onClick = {() => {
                                    setTypeProfile("Facebook and Instagram");
                                    setShowProfileTypeBox(false)
                                }}
                            >
                                Facebook and Instagram
                            </span>
                        </div>
                    </span>
                    <span className = "filterInputsSpan">
                        <select className = "filterInput" value={country} onChange={e => setCountry(e.target.value)}>
                            <option selected = {true} value = "">Country</option>
                            {
                                countryData.map(elem => <option key = {elem.id} value = {elem.country}>{ elem.country }</option>)
                            }
                        </select>
                    </span>
                </div>
                <div className = "filterBtnsBox">
                    <button 
                        className = "filterButton" 
                        style = {{
                            color: fullName || facebookID || instagramID || category || typeProfile ? "white" : "#3F68B1",
                            backgroundColor: fullName || facebookID || instagramID || category || typeProfile ? "#3F68B1" : "#FAFAFA"
                        }}
                        onClick = { filterUsersList }
                    >
                        FILTER
                    </button>
                    <button 
                        className = "clearButton"
                        style = {{
                            color: fullName || facebookID || instagramID || category || typeProfile ? "#819F10" : "#929292"
                        }}
                        onClick = { clearFilterData }
                    >
                        CLEAR
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FilterAllUsers